import type { FC } from 'react';
import type { BeneficialOwnerResponse } from '@gcv/shared';

import { Button, Dialog, Text } from 'ui';

interface Props {
  isOpen: boolean;
  owner: BeneficialOwnerResponse;
  thresholdPercentage: number;
  serviceProviderName: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmLowThresholdBeneficialOwnerModal: FC<Props> = ({
  isOpen,
  owner,
  thresholdPercentage,
  serviceProviderName,
  onClose,
  onConfirm
}) => {
  const ownerName = [
    owner.beneficial_owner_first_name,
    owner.middle_initial,
    owner.beneficial_owner_last_name
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Dialog
      dataCy="confirm-low-threshold-beneficial-owner-modal"
      cancelButtonText="Go Back"
      handleClose={onClose}
      isOpen={isOpen}
      title={`Report ${ownerName} as meeting the ${thresholdPercentage}% threshold?`}
      action={<Button color="primary" label="Report Anyway" onClick={onConfirm} />}
    >
      <Text
        content={`${ownerName} is listed at ${owner.ownership_in_this_business}%, below the ${thresholdPercentage}% threshold ${serviceProviderName} requires. Checking this box reports them as meeting it.`}
        type="body1"
        sx={{ pb: 1 }}
      />
      <Text
        content={`You don't need to check it to name them your controlling or managing individual.`}
        type="body1"
      />
    </Dialog>
  );
};
